export enum CheckStatus {
    '未提交',
    '审核中',
    '审核通过',
    '被驳回'
}

export enum Status {
    '下架',
    '上架'
}
// 类型
export enum offTypes {
    '商品溢价' = 1,
    '折扣不合格',
    '信息有误',
    '质量问题',
    '口感不佳',
    '永久下架' = 10,
    '整改下架' = 11,
}